var map = {
	"./avatar-omar-base-full.png": 53719,
	"./avatar-omar-fall-full.png": 11715,
	"./avatar-omar-spring-full.png": 55187,
	"./avatar-omar-summer-full.png": 92243,
	"./avatar-omar-travel-full.png": 97842,
	"./avatar-omar-winter-full.png": 65711
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2082;